import React, { useRef, useEffect } from "react";
import Slider from "react-slick";
import { useSelector } from "react-redux";

const VideoCarousel = () => {
    const {
        activeVideoList,
        activeTagList,
        tagList
    } = useSelector((state) => state.VideoReducer);

    const slider = useRef();

    useEffect(() => {
        slider.current.slickGoTo(0);
    }, [activeVideoList]);

    const settings = {
        speed: 500,
        slidesToShow: activeVideoList.length,
        vertical: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: activeVideoList.length,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    vertical: false,
                    dots: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.5,
                    vertical: false,
                    dots: true,
                }
            }
        ],
    };

    // If Video has multiple tags, only display 2 tags, and prioritize tags that Mellby has created in backoffice.
    const displayTags = (item) => {
        const activedTagsInTagList = JSON.parse(tagList.tagList).filter(tag => activeTagList.includes(tag.toLowerCase())).map(tag => tag.toLowerCase());
        const matchingTags = item.tags
            .filter(tag => activedTagsInTagList.includes(tag.toLowerCase()))
            .map(tag => tag.toLowerCase());
        let displayTags = [];
        if (matchingTags.length >= 2) {
            displayTags = matchingTags.slice(0, 2);
        } else if (matchingTags.length === 1 && item.tags.length >= 2) {
            const firstTag = matchingTags[0];
            const secondTag = item.tags
                .find(tag => !matchingTags.includes(tag.toLowerCase()))?.toLowerCase();
            displayTags = [firstTag, secondTag];
        } else {
            displayTags = item.tags.length >= 2 ? item.tags.slice(0, 2).map(tag => tag.toLowerCase()) : item.tags;
        }
        displayTags = displayTags.map(tag => tag.charAt(0).toUpperCase() + tag.slice(1));

        return (
            <div className="vc-tag_container">
                {displayTags.map((tag, index) => (
                    <div key={index}>
                        <p>{tag}</p>
                    </div>
                ))}
            </div>
        );
    };

    const handleClick = (videoId) => {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('videoId', videoId);

        const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
        window.location.href = newUrl;
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const videoPageDefaultThumbnail = document.getElementById("video-page-defaultThumbnail");
    const thumbnailData = videoPageDefaultThumbnail.getAttribute("data-defaultThumbnail");
    const parasedThumbnailData = JSON.parse(thumbnailData);
    const url = parasedThumbnailData.Url;
    const currentDomain = window.location.hostname;
    const storageUrlDefaultThumbnail = "https://" + currentDomain + url;

    return (
        <div className="video-carousel__container">
            <Slider {...settings} ref={slider}>
                {activeVideoList.filter(item => item.videoId).map((item, index) => (
                    <div
                        className={`video-carousel-item video-carousel-item-${index}`}
                        key={index}
                        onClick={() => handleClick(item.videoId)}
                    >
                        <div className="vc-img_container">
                            {item.thumbnail.imageData ? (
                                <img src={item.thumbnail.url} alt="Video Thumbnail" />
                            ) : (
                                <img src={storageUrlDefaultThumbnail} alt="Video Thumbnail" />
                            )}
                        </div>

                        {displayTags(item)}

                        <div className="vc-title_container">
                            <p>{item.title}</p>
                        </div>
                        {item.description !== "" &&
                            <div className="vc-description_container" dangerouslySetInnerHTML={{ __html: item.description }}>
                            </div>
                        }
                        <div className="vc-publish_container">
                            <p>{formatDate(item.publishedAt)}</p>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default VideoCarousel;